import {match} from 'ts-pattern';

import {EntityResourceIds} from '@dms/api/shared';

import {RelatedCustomNoticesResourceId} from './types';

export function composeRelatedCustomNoticesUrl(
  resourceId: RelatedCustomNoticesResourceId,
  recordId: string
) {
  // Route params arrive percent-decoded, so a crafted id could otherwise splice
  // path segments or a query string into the request
  const encodedRecordId = encodeURIComponent(recordId);

  return match(resourceId)
    .with(
      EntityResourceIds.customer,
      () => `/dms/v1/customerV2/${encodedRecordId}/related-custom-notices`
    )
    .with(
      EntityResourceIds.vehicle,
      () => `/dms/v1/vehicle/${encodedRecordId}/related-custom-notices`
    )
    .with(
      EntityResourceIds.businessCase,
      () => `/dms/v1/business-case/${encodedRecordId}/related-custom-notices`
    )
    .with(
      EntityResourceIds.interest,
      () => `/dms/v1/interest/${encodedRecordId}/related-custom-notices`
    )
    .with(
      EntityResourceIds.rentalOrder,
      () => `/dms/v1/rental-order/${encodedRecordId}/related-custom-notices`
    )
    .with(
      EntityResourceIds.serviceCase,
      () => `/dms/v1/workshop/service-case/${encodedRecordId}/related-custom-notices`
    )
    .with(
      EntityResourceIds.tireOrder,
      () => `/dms/v1/workshop/tire-order/${encodedRecordId}/related-custom-notices`
    )
    .with(
      EntityResourceIds.workshopInterest,
      () => `/dms/v1/workshop/interest/${encodedRecordId}/related-custom-notices`
    )
    .with(
      EntityResourceIds.directSale,
      () => `/dms/v1/warehouse/direct-sale/${encodedRecordId}/related-custom-notices`
    )
    .exhaustive();
}
